import { ROUTES } from 'static/menusConstants'
import { useRouter } from 'next/router'
import { H4, P2, Container, Tag } from '@moneymade/moneymade-ui'
import PropTypes from 'prop-types'

import styles from './AssetBlock.module.scss'

const AssetBlock = ({ title, subtitle, subTitle, tags, guid }) => {
  const { push } = useRouter()
  return (
    <Container width={600} className={styles.AssetBlock}>
      {title && (
        <H4 weight="bold" type="heading" className={styles.Title} id={guid}>
          {title}
        </H4>
      )}
      {(subtitle || subTitle) && <P2 className={styles.SubTitle}>{subtitle || subTitle}</P2>}
      <div className={styles.ContainerTag}>
        {tags.map(({ slugAssetTag, iconClass, nameTag }, index) => (
          <Tag
            key={`tag-${index}`}
            size="md"
            weight="light"
            icon={iconClass}
            onClick={() => push(`/${ROUTES.assetPage}/${slugAssetTag}`)}
          >
            {nameTag}
          </Tag>
        ))}
      </div>
    </Container>
  )
}

AssetBlock.propTypes = {
  title: PropTypes.string,
  guid: PropTypes.string,
  subtitle: PropTypes.string,
  subTitle: PropTypes.string,
  tags: PropTypes.arrayOf(PropTypes.object)
}

AssetBlock.defaultProps = {
  title: '',
  subtitle: '',
  guid: '',
  subTitle: '',
  tags: []
}
export default AssetBlock
